/**
 * Memoizes functions, typically React event handlers.
 * When used together with PureComponent, this lets you achieve lots fewer renders.
 */
export default function memoize(
  handlers: { [key: string]: any },
  arg: any | null,
  functionCreator: (arg: any | null) => (val?: any) => void
) {
  const argJson = JSON.stringify(arg)
  if (handlers[argJson] == null) {
    handlers[argJson] = functionCreator(arg)
  }
  return handlers[argJson]
}

export interface MemoizeStore<T> {
  [key: string]: (arg: T) => void
}
